export default "__VITE_ASSET__0a826d3a__"